import { localStorageModule } from "@/modules/local-storage";

export const clientEnvIsIosApp = (): boolean => {
  if (localStorageModule.readFromIosApp()) return true;
  // eslint-disable-next-line no-restricted-properties
  const params = new URLSearchParams(window.location.search);
  return params.get("from-ios-app") === "1";
};
